import { TFormField } from '@/interfaces/form'
import { Col, Form, InputNumber, Select } from 'antd'
import { signal } from '@preact/signals-react'

import './styles.scss'
import { TFieldProps } from '..'
import { Rule } from 'antd/es/form'

const selectBefore = (
  <Select defaultValue='add'>
    <Select.Option value='add'>+</Select.Option>
    <Select.Option value='minus'>-</Select.Option>
  </Select>
)

const currencySymbol = signal('$')

const selectAfter = (
  <Select onChange={(value) => (currencySymbol.value = value)} defaultValue='$'>
    <Select.Option value='$'>$</Select.Option>
    <Select.Option value='€'>€</Select.Option>
    <Select.Option value='£'>£</Select.Option>
    <Select.Option value='¥'>¥</Select.Option>
  </Select>
)

const currencyFormatter = (value: string | number | undefined) => {
  if (!value) return ''
  // Format value as currency with comma separators
  return `${currencySymbol.peek()}${Number(value).toLocaleString()}`
}

const currencyParser = (value: string | undefined) => {
  if (!value) return ''
  // Remove non-numeric characters (e.g., '$' and ',')
  return value.replace(
    new RegExp(`\\${currencySymbol.peek()}\\s?|(,*)`, 'g'),
    ''
  )
}

export default function CurrencyFormField({ fieldInfo }: TFieldProps) {
  const setFieldRules = (): Rule[] => {
    const rules: Rule[] = []

    if (fieldInfo.required) {
      rules.push({
        required: true,
        message: 'Este campo es obligatorio',
      })
    }

    return rules
  }
  return (
    <Col
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-end',
      }}
      xxl={4}
      xl={6}
      md={8}
      sm={12}
      xs={24}
    >
      <Form.Item
        className={`currency-field ${fieldInfo.className ?? ''}`}
        label={fieldInfo.label}
        name={fieldInfo.name}
        required={fieldInfo.required}
        tooltip={fieldInfo.description}
        rules={setFieldRules()}
      >
        <InputNumber
          size='small'
          addonBefore={selectBefore}
          addonAfter={selectAfter}
          formatter={currencyFormatter}
          parser={currencyParser}
        />
      </Form.Item>
    </Col>
  )
}
